<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-row mb-1">
      <span class="badge badge-light mt-auto mb-auto">{{ lineIndex + nodeData.seq }}</span>
      <b-form-input type="text" v-model="nodeData.name" placeholder="表格名" class="w-50 h-auto"></b-form-input>
      <button type="button" class="btn btn-outline-danger ml-2" @click="emitRemoveNodeEvent">删除</button>
    </div>
    <table class="table table-bordered" v-if="lazyLoad">
      <thead class="thead-light">
      <tr>
        <th>
          <el-popover
              placement="right"
              v-model="cornerPopoverVisible">
            <div class="d-flex flex-row">
              <el-button type="primary" size="mini" @click="rowChange(0,false)">下方新增</el-button>
              <el-button type="primary" size="mini" @click="columnClick(-1,'new')" class="ml-1">右侧新增</el-button>
            </div>
            <template slot="reference">
              <div>#</div>
            </template>
          </el-popover>
        </th>
        <th v-for="(column,index) in nodeList"
            :key="index">
          <el-popover
              placement="top"
              v-model="columnPopoverVisible[index]">
            <div class="text-right m-0 d-flex flex-row">
              <el-button size="mini" type="text" @click="deleteColumn(index)">删除列</el-button>
              <el-button size="mini" type="text" @click="columnClick(index,'edit')">编辑列</el-button>
              <el-button type="primary" size="mini" @click="columnClick(index,'new')">右侧新增</el-button>
            </div>
            <template slot="reference">
              <div>{{ column.name }}</div>
            </template>
          </el-popover>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="index in rowIndex" :key="index">
        <th>
          <el-popover
              placement="left"
              v-model="rowPopoverVisible[index - 1]">
            <div class="m-0 d-flex flex-column">
              <el-button size="mini" type="text" @click="rowDeleteConfirm(index)">删除行</el-button>
              <el-button type="primary" size="mini" @click="rowChange(index,false)">下方新增</el-button>
            </div>
            <template slot="reference">
              <div>{{ index }}</div>
            </template>
          </el-popover>
        </th>
        <td v-for="(column,seq) in nodeList" :key="index + seq">
          <el-input
              v-if="(column.format === undefined || column.format == null) && dataMatrix[index-1][seq].format === undefined"
              clearable
              v-model="dataMatrix[index-1][seq].name"></el-input>
          <el-input v-if="column.format==='String'"
                    v-model="column.defaultValue"
                    disabled
                    placeholder="空"></el-input>
          <el-input-number v-else-if="column.format==='Integer'"
                           v-model="column.defaultValue"
                           disabled></el-input-number>
          <el-checkbox v-else-if="column.format==='Boolean'"
                       v-model="column.defaultValue"
                       disabled
                       class="m-auto"></el-checkbox>
        </td>
      </tr>
      </tbody>
    </table>

    <el-dialog title="表格列" :visible.sync="columnDialog" @close="dialogClosed">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row">
          <el-input v-model="columnObject.name" placeholder="列名"></el-input>
          <el-checkbox v-model="columnObject.editAble" class="ml-2 mt-2 mb-2">待编辑列</el-checkbox>
        </div>
        <div v-if="columnObject.editAble" class="mt-2">
          <el-select v-model="columnObject.format" placeholder="数据格式">
            <el-option label="文本" value="String"/>
            <el-option label="数字" value="Integer"/>
            <el-option label="单选" value="Boolean"/>
          </el-select>
          <el-input v-if="columnObject.format==='String'"
                    v-model="columnObject.defaultValue"
                    class="mt-2"
                    placeholder="默认值"></el-input>
          <el-input-number v-else-if="columnObject.format==='Integer'"
                           v-model="columnObject.defaultValue"
                           class="ml-2"></el-input-number>
          <el-checkbox v-else-if="columnObject.format==='Boolean'"
                       v-model="columnObject.defaultValue"
                       class="ml-2">默认值
          </el-checkbox>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="columnDialog = false">取 消</el-button>
        <el-button type="primary" @click="columnSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QualityInspectTemplateTableUnit",
  props: {
    nodeData: {
      type: Object,
      required: true
    },
    lineIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rowIndex: 0,
      dataMatrix: [],
      cornerPopoverVisible: false,
      columnPopoverVisible: [],
      rowPopoverVisible: [],
      lazyLoad: false,
      nodeList: [],
      columnDialog: false,
      columnEdit: false,
      columnObject: {
        columnIndex: -1,
        name: null,
        editAble: false,
        format: null,
        defaultValue: null
      }
    }
  },
  computed: {
    maxColumnRows() {
      let temp = 0;
      for (let item of this.nodeList) {
        if (item.childNodes !== undefined && item.childNodes instanceof Array) {
          for (let node of item.childNodes) {
            if (node.seq > temp) {
              temp = node.seq;
            }
          }
        }
      }
      return temp;
    }
  },
  watch: {
    nodeList: {
      deep: true,
      handler() {
        this.initMatrix();
        this.initPopoverVisible();
      }
    }
  },
  mounted() {
    //init list
    if (this.nodeData.hasOwnProperty('childNodes') && this.nodeData.childNodes instanceof Array) {
      this.nodeList = JSON.parse(JSON.stringify(this.nodeData.childNodes));
      this.nodeList.sort((a, b) => {
        if (a.seq > b.seq) {
          return 1;
        }
        if (a.seq < b.seq) {
          return 2;
        }
        return 0;
      })
    }
    this.rowIndex = this.maxColumnRows;
    this.initMatrix();
    this.initPopoverVisible();
    if (this.dataMatrix.length === 0) {
      this.rowChange(0, false);
    }
  },
  methods: {
    initPopoverVisible() {
      this.columnPopoverVisible = [];
      this.rowPopoverVisible = [];
      // eslint-disable-next-line no-unused-vars
      for (let item of this.nodeList) {
        this.columnPopoverVisible.push(false);
      }
      for (let i = 0; i < this.rowIndex; i++) {
        this.rowPopoverVisible.push(false);
      }
      this.lazyLoad = true;
    },
    initMatrix() {
      let temp = [];
      for (let item of this.nodeList) {
        let tempList = new Array(this.rowIndex);
        if (item.hasOwnProperty('childNodes') && item.childNodes instanceof Array) {
          for (let node of item.childNodes) {
            tempList[node.seq - 1] = node;
          }
        }
        temp.push(tempList);
      }

      if (this.rowIndex > 0) {
        //旋转
        let tempMatrix = new Array(this.rowIndex);
        for (let i = 0; i < this.rowIndex; i++) {
          let tempRow = [];
          for (let row of temp) {
            tempRow.push(row[i] === undefined ? {type: 4, seq: i + 1} : row[i]);
          }
          tempMatrix[i] = tempRow;
        }
        this.dataMatrix = tempMatrix;
      } else {
        this.dataMatrix = [];
      }
    },
    columnClick(index, op) {
      if (op === 'edit') {
        let item = this.nodeList[index];
        if (item instanceof Object) {
          this.columnObject.name = item.name;
          if (item.format != null) {
            this.columnObject.editAble = true;
            this.columnObject.format = item.format;
            this.columnObject.defaultValue = item.defaultValue;
          }
          this.columnEdit = true;
        } else {
          this.$message.error('数组下标异常');
          return;
        }
      }
      this.columnObject.columnIndex = index;
      this.columnDialog = true;
    },
    columnSubmit() {
      if (!this.columnObject.editAble) {
        this.columnObject.format = null;
        this.columnObject.defaultValue = null;
      }
      if (this.columnEdit) {
        //edit
        this.nodeList[this.columnObject.columnIndex].name = this.columnObject.name;
        this.nodeList[this.columnObject.columnIndex].format = this.columnObject.format;
        this.nodeList[this.columnObject.columnIndex].defaultValue = this.columnObject.defaultValue;
      } else {
        //new
        if (this.columnObject.name == null || this.columnObject.name === '') {
          this.$message.error('列名不能为空');
        } else {
          let tempList = [];
          for (let i = 1; i <= this.rowIndex; i++) {
            tempList.push({
              name: null,
              type: 4,
              seq: i
            })
          }
          this.nodeList.splice(this.columnObject.columnIndex + 1, 0, {
            name: this.columnObject.name,
            format: this.columnObject.format,
            defaultValue: this.columnObject.defaultValue,
            type: 3,
            childNodes: tempList
          });
        }
      }

      this.columnDialog = false;
    },
    deleteColumn(index) {
      this.$confirm('确认删除表格列?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.columnPopoverVisible[index] = false;
        this.nodeList.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
    },
    dialogClosed() {
      this.columnObject = {
        columnIndex: -1,
        name: null,
        editAble: false,
        format: null,
        defaultValue: null
      };
      this.columnEdit = false;
    },
    rowDeleteConfirm(index) {
      this.$confirm('确认删除行?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.rowChange(index, true);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
    },
    rowChange(index, isDelete) {
      this.rowPopoverVisible[index - 1] = false;
      let tempNodeList = JSON.parse(JSON.stringify(this.nodeList));
      for (let i = 0; i < tempNodeList.length; i++) {
        let childNodes = tempNodeList[i].childNodes;
        if (childNodes === undefined) {
          childNodes = [];
        }
        for (let j = 0; j < childNodes.length; j++) {
          let item = childNodes[j];
          if (item !== undefined && item.hasOwnProperty('seq')) {
            if (isDelete) {
              if (item.seq === index) {
                item.seq = -1;
              } else if (item.seq > index) {
                item.seq -= 1;
              }
            } else {
              if (item.seq > index) {
                item.seq += 1;
              }
            }
          }
        }
        let tempList = [];
        for (let item of childNodes) {
          if (!isDelete || item.seq !== -1) {
            tempList.push(item);
          }
        }
        if (!isDelete) {
          tempList.push({
            name: null,
            seq: index + 1,
            type: 4
          })
        }
        tempNodeList[i].childNodes = tempList;
      }
      this.rowIndex += isDelete ? -1 : 1;
      if (this.rowIndex <= 0) {
        this.rowIndex = 1;
      }
      this.nodeList = tempNodeList;
    },
    exportData() {
      if (this.nodeData.name == null || this.nodeData.name === '') {
        this.$message.error('存在未命名的表格');
        return null;
      }
      let result = JSON.parse(JSON.stringify(this.nodeData));
      for (let i = 0; i < this.nodeList.length; i++) {
        let tempList = [];
        for (let j = 0; j < this.dataMatrix.length; j++) {
          let item = this.dataMatrix[j][i];
          if (item.name != null) {
            tempList.push(item);
          }
        }
        this.nodeList[i].childNodes = tempList;
        this.nodeList[i].seq = i + 1;
      }
      result.childNodes = this.nodeList;
      return result;
    },
    emitRemoveNodeEvent() {
      this.$emit('removeNode')
    },
  }
}
</script>

<style scoped>

</style>